import { type ComponentType, type FC } from "react";
import { Navigate, useLocation } from "react-router-dom";
import type { CampaignDraft } from "src/services/CampaignDraftTypes";
import type { CampaignData } from "../../EngagementInterfaces";
import { CREATE_CAMPAIGN_ROUTE } from "../Tabs/EmailCampaign/AiEmail/AiCampaignConstants";
import { draftToCampaignData, type DraftLocationState } from "./CampaignDraftUtils";

interface CampaignEditorRouteProps {
  Wizard: ComponentType<{ campaignData: Partial<CampaignData>; initialDraft?: CampaignDraft | null }>;
}

const CampaignEditorRoute: FC<CampaignEditorRouteProps> = ({ Wizard }) => {
  const locationState = useLocation().state as DraftLocationState | null;
  const draft = locationState?.draft ?? null;
  const campaignData = locationState?.campaignData ?? (draft ? draftToCampaignData(draft) : undefined);

  if (!campaignData) {
    return <Navigate to={CREATE_CAMPAIGN_ROUTE} replace />;
  }

  return <Wizard campaignData={campaignData} initialDraft={draft} />;
};

export default CampaignEditorRoute;
